import { Component, OnInit } from '@angular/core';
import { ApiServicesService } from '../../services/api-services.service';
import { ToastrService } from 'ngx-toastr';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-e-consent',
  templateUrl: './e-consent.component.html',
  styleUrls: ['./e-consent.component.scss']
})
export class EConsentComponent implements OnInit {

  eConsentData: any;
  companyId: number = null;
  beneficiaryId: number = null;
  noEConsnt: boolean = false;  

  constructor(
    private toastService: ToastrService,
    private apiService: ApiServicesService, 
  ) { }

  ngOnInit(): void {
    this.beneficiaryId = parseInt(sessionStorage.getItem('listBeneficiaryId'));
    this.companyId = parseInt(sessionStorage.getItem('companyId')); 

    this.checkEConsentAcknowledgement();
  }


  checkEConsentAcknowledgement(){   
      this.apiService.getBeneficiaryEConsentCompany(this.beneficiaryId, this.companyId).subscribe({      
        next: (result: any) => {
          if(result){ 
            if (result.status === 200) {              
              this.eConsentData = result.data; 
            }else if(result.status === 204){              
              this.noEConsnt = true;
            }                    
          }
        },
        error: (err) => {
          CustomErrorToastComponent.showErrorToast(this.toastService, err);
        },
      });   
    }

}
